import Button from "../../../../conponents/Button/Button.jsx";

import styles from "./SaveProfileSection.module.css";

const SaveProfileSection = ({

    loading,

    onSubmit,

}) => {

    return (

        <div className={styles.wrapper}>

            <Button

                type="submit"

                loading={loading}

                onClick={onSubmit}

            >

                ذخیره تغییرات

            </Button>

        </div>

    );

};

export default SaveProfileSection;